import React from "react";
import "./Program_Structure.css";
import Accordion from "react-bootstrap/Accordion";

const semesterData = [
  {
    semester: "Semester 1",
    subjects: [
      "Fundamentals of Management",
      "Basics of Accounting",
      "Introduction to Economics",
      "Introduction to IT",
      "Business English",
      "Environmental Awareness and Disaster Management",
    ],
  },
  {
    semester: "Semester 2",
    subjects: [
      "Basics of Financial Management",
      "Indian Economy",
      "Business Environment",
      "Banking Operations",
      "Introduction to Psychology",
      "Soft Skills I",
    ],
  },
  {
    semester: "Semester 3",
    subjects: [
      "Fundamentals of Cost Accounting",
      "Financial Accounting I",
      "Corporate Accounting I",
      "Indian Banking System",
      "Introduction to Digital Marketing",
      "Soft Skills II",
    ],
  },
  {
    semester: "Semester 4",
    subjects: [
      "Entrepreneurship Development",
      "Corporate Accounting II",
      "Financial Accounting II",
      "Human Resource Management",
      "Consumer Behaviour",
      "Business Ethics and Corporate Governance",
    ],
  },
  {
    semester: "Semester 5",
    subjects: [
      "Investment and Portfolio Management",
      "Marketing of Financial Services",
      "Research Methodology",
      "Business Finance",
      "Indian Financial System and Financial Market",
    ],
  },
  {
    semester: "Semester 6",
    subjects: [
      "Analysis of Financial Statements",
      "Fundamentals of E-Commerce",
      "Direct and Indirect Tax",
      "Long Term Finance",
      "Project Work",
    ],
  },
];

const Program_Structure = () => {
  return (
    <section className="SemesterAccordion" id="programs">
      <div className="container">
        <div className="semester-inner">
          <div className="semester-heading">
            <span className="semester-small-title">Program Structure</span>
            <span className="semester-heading-line"></span>
          </div>

          <Accordion
            // defaultActiveKey={["0"]}
            className="semester-accordion"
          >
            <div className="row semester-row">
              {semesterData.map((semester, index) => (
                <div
                  className="col-lg-6 col-md-6 col-sm-6 col-12 semester-col mb-2"
                  key={semester.semester}
                >
                  <Accordion.Item
                    eventKey={String(index)}
                    className="semester-item"
                  >
                    <Accordion.Header>
                      <span className="semester-name">{semester.semester}</span>
                    </Accordion.Header>

                    <Accordion.Body>
                      <div className="semester-subjects">
                        {semester.subjects.map((subject, subjectIndex) => (
                          <div className="semester-subject" key={subjectIndex}>
                            <span className="subject-icon">✓</span>

                            <span className="subject-text">{subject}</span>
                          </div>
                        ))}
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </div>
              ))}
            </div>
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default Program_Structure;
